import { useCallback } from 'react';
import { useAppClockService } from '@mews/framework';
import { ReservationLinkResult, ReservationTimeState } from '@mews-commander/data-access';

const checkInOffset = Number.MIN_SAFE_INTEGER;
const futureOffset = Number.MIN_SAFE_INTEGER / 2;
const pastOffset = Number.MIN_SAFE_INTEGER / 3;

const getReservationSortValue = (r: ReservationLinkResult, now: number, scopedReservationIds?: string[]) => {
    const isScoped = scopedReservationIds?.includes(r.reservationId);
    const startUtc = new Date(r.reservationStartUtc).valueOf();
    const endUtc = new Date(r.reservationEndUtc).valueOf();

    const diff = startUtc - now;

    switch (r.reservationTimeState) {
        // if reservation is in the future, we want to have the closest one to the current time at the top
        case ReservationTimeState.Future:
            return startUtc - now + (isScoped ? futureOffset : 0);
        // if reservation is currently happening, we want to have the closest checkout time to the current time at the top
        case ReservationTimeState.CheckInMissed:
        case ReservationTimeState.CheckedIn:
        case ReservationTimeState.ToBeCheckedOut:
        case ReservationTimeState.ToBeCheckedIn:
            return endUtc - now + (isScoped ? checkInOffset : 0);
        default:
            return (diff < 0 ? -diff : diff) + (isScoped ? pastOffset : -pastOffset);
    }
};

export const useSortReservationForLinking = (scopedReservationIds?: string[]) => {
    const appClockService = useAppClockService();
    const now = appClockService.getValue();

    return useCallback(
        (a: ReservationLinkResult, b: ReservationLinkResult) => {
            return (
                getReservationSortValue(a, now, scopedReservationIds) -
                getReservationSortValue(b, now, scopedReservationIds)
            );
        },
        [now, scopedReservationIds]
    );
};
